const dummyVideoImage = "/media/dummy/video_dummy.png";
const dummyDocumentImage = "/media/dummy/document_dummy.png";

export const getImageFromFilesbyKey = (files = [], videoId, key = "", type_id = 1, fallback = null) => {
  const imageFile =
    files &&
    files.find(
      (file) => file.video_id === parseInt(videoId) && file.type.key === key
    );

  if (imageFile) return imageFile.public_url;

  return fallback || (type_id === 1 ? dummyVideoImage : dummyDocumentImage);
};

export const getImagesFromFilesbyKey = (files = [], videoId, key = "", type_id = 1, fallback = null) => {
  const imageFiles =
    files &&
    files.filter(
      (file) => file.video_id === parseInt(videoId) && file.type.key === key
    );
  const sortNewFirst = imageFiles.sort((a, b) => b.id - a.id);

  const filesWithNewUrl = sortNewFirst.map((file) => ({
    ...file,
    public_url: file.public_url || fallback || (type_id === 1 ? dummyVideoImage : dummyDocumentImage),
  }));

  return filesWithNewUrl;
};